import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/services/chauffeur-services.png";

const services: ChauffeurPage = {
  slug: "services",
  title: "Chauffeur privé & VTC – Services",
  subtitle: "Prestations VTC haut de gamme et chauffeur privé sur-mesure.",
  keywords: [
    "chauffeur privé",
    "VTC",
    "services VTC",
    "chauffeur Cannes",
    "VTC Cannes",
  ],
  hero: {
    title: "Chauffeur privé & VTC – Services",
    subtitle: "Prestations VTC haut de gamme et chauffeur privé sur-mesure.",
    keywords: ["chauffeur privé", "VTC", "services premium"],
    imageSrc: heroImage.src,
    imageAlt: "Chauffeur privé – Services premium",
    badges: [
      "Ponctualité 24/7",
      "Véhicules haut de gamme",
      "Chauffeurs experts",
    ],
  },
  benefits: {
    heading: "Pourquoi choisir nos chauffeurs privés",
    items: [
      {
        title: "Ponctualité 24/7",
        description: "Disponibilité continue et suivi en temps réel.",
      },
      {
        title: "Confort premium",
        description: "Véhicules haut de gamme et espace généreux.",
      },
      {
        title: "Expérience locale",
        description:
          "Chauffeurs basés à Cannes, connaissant toute la Côte d’Azur.",
      },
    ],
  },
  services: {
    heading: "Nos services VTC",
    services: [
      {
        title: "Mise à disposition",
        text: "Chauffeur privé à l’heure, demi-journée ou journée à Cannes.",
      },
      {
        title: "Transferts aéroports",
        text: "Nice, Cannes, Monaco – accueil personnalisé, suivi de vol.",
      },
      {
        title: "Événements",
        text: "Logistique, navettes, VIP, roadshows à Cannes et sur la Côte.",
      },
      {
        title: "Business",
        text: "Déplacements d’équipes, clients, partenaires sur Cannes & Sophia.",
      },
    ],
  },
  locations: {
    heading: "Zones desservies",
    items: [
      { name: "Cannes" },
      { name: "Nice" },
      { name: "Antibes" },
      { name: "Monaco" },
      { name: "Saint‑Tropez" },
      { name: "Riviera italienne" },
      { name: "Milan" },
    ],
  },
  generic: {
    heading: "Excellence & flexibilité",
    subheading:
      "Des solutions adaptées à chaque trajet: transferts, business, événements.",
    paragraphs: [
      "Basés à Cannes, nous coordonnons vos déplacements avec rigueur et discrétion, en tenant compte des délais réels, des zones de dépôt sensibles et des contraintes d'accès.",
      "Sur toute la Côte d'Azur, notre réseau répond aux besoins spécifiques (horaires étendus, VIP, besoins entreprise) sans multiplier les interlocuteurs.",
      "Ce service est adapté autant pour un usage ponctuel que pour une organisation récurrente: transferts, mise à disposition, roadshows et accompagnement événementiel.",
    ],
    bullets: [
      "Réactivité 24/7",
      "Suivi et communication claire",
      "Flotte adaptée (berline, SUV, van)",
    ],
  },
  process: {
    heading: "Parcours client services chauffeur",
    steps: [
      "Brief rapide de votre besoin (trajet, timing, niveau de service).",
      "Proposition de format de prestation et estimation claire.",
      "Validation du plan de prise en charge avec consignes précises.",
      "Exécution terrain avec suivi jusque l'arrivée.",
    ],
  },
  faq: [
    {
      q: "Quelle difference entre transfert simple et mise a disposition ?",
      a: "Le transfert couvre un trajet défini, tandis que la mise à disposition vous laisse le véhicule et le chauffeur sur une plage horaire dédiée.",
    },
    {
      q: "Pouvez-vous gérer plusieurs passagers en parallèle ?",
      a: "Oui, nous organisons des flux multi-passagers avec coordination centralisée selon vos points de prise en charge.",
    },
    {
      q: "Le service est-il adapte aux demandes last minute ?",
      a: "Oui, selon disponibilité immédiate. Nous confirmons rapidement faisabilité et délais de départ.",
    },
  ],
  relatedLinks: [
    { label: "Transferts, tarifs et durées", href: "/chauffeur/transferts" },
    { label: "Chauffeur pour événements", href: "/chauffeur/evenements" },
    { label: "Service corporate entreprise", href: "/chauffeur/entreprise" },
  ],
  cta: {
    title: "Obtenir un devis VTC",
    text: "Expliquez-nous votre besoin, nous répondons rapidement avec une offre claire.",
    primaryHref: "/contact",
    primaryLabel: "Demander un devis",
  },
  seo: {
    title: "Chauffeur privé & VTC – Services premium",
    description:
      "Services chauffeur privé et VTC premium à Cannes et sur la Côte d’Azur: transferts, événements, business.",
    canonical: "/chauffeur/services",
  },
};

export default services;
